export const data = [
  {
    qId: 0,
    text: "How much are you looking to spend?",
    options: [
      {
        text: "Under $100",
        nextQId: 1,
        possibleResultsIds: [9, 10, 11, 14, 16, 17],
      },
      {
        text: "Under $250",
        nextQId: 1,
        possibleResultsIds: [9, 17, 5, 6, 7, 12, 13, 15],
      },
      {
        text: "Over $250",
        nextQId: 1,
        possibleResultsIds: [1, 3, 4, 8, 18],
      },
    ],
  },
  {
    qId: 1,
    text: "Do you want in-ears or over-ear headphones?",
    options: [
      {
        text: "I want earbuds.",
        nextQId: 2,
        possibleResultsIds: [9, 3, 5, 6, 10, 11, 13, 15, 17, 18],
      },
      {
        text: "I want over-ears.",
        nextQId: 2,
        possibleResultsIds: [1, 4, 7, 8, 12, 14, 16],
      },
    ],
  },
  {
    qId: 2,
    text: "Do you want wired or wireless headphones?",
    options: [
      {
        text: "I prefer a cable.",
        nextQId: 3,
        possibleResultsIds: [7, 8, 9, 16, 18],
      },
      {
        text: "I'm tired of cables and dongles!",
        nextQId: 3,
        possibleResultsIds: [1, 3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 17],
      },
    ],
  },
  {
    qId: 3,
    text: "Do you want a microphone for calls?",
    options: [
      {
        text: "Nope, I don't care.",
        nextQId: 5,
        possibleResultsIds: [
          1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
      },
      {
        text: "Yes, I need one for calls.",
        nextQId: 4,
        possibleResultsIds: [1, 3, 4, 5, 6, 10, 11, 13, 14, 15, 17],
      },
    ],
  },
  {
    qId: 4,
    text: "Do you want noise canceling?",
    options: [
      {
        text: "Yes, I need it.",
        nextQId: 5,
        possibleResultsIds: [1, 3, 4, 5, 6, 10, 14, 15],
      },
      {
        text: "No, I don't need it.",
        nextQId: 5,
        possibleResultsIds: [11, 12, 13, 14, 17, 18],
      },
    ],
  },
  {
    qId: 5,
    text: "Do you plan to workout in these headphones?",
    options: [
      {
        text: "Yes, I workout daily",
        nextQId: 6,
        possibleResultsIds: [3, 5, 6, 10, 13, 11, 15, 17],
      },
      {
        text: "No, never",
        nextQId: 6,
        possibleResultsIds: [
          1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
      },
      {
        text: "Sometimes",
        nextQId: 6,
        possibleResultsIds: [3, 5, 6, 10, 13, 11, 15, 17],
      },
    ],
  },
  {
    qId: 6,
    text: "Do you prefer Apple-made headphones?",
    options: [
      {
        text: "Yes.",
        nextQId: null,
        possibleResultsIds: [4, 5, 17],
      },
      {
        text: "Don't care.",
        nextQId: null,
        possibleResultsIds: [1, 3, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18],
      },
    ],
  },
]
